@if (currentLang == 'en-US') {
	<a id="dekra-logo" [title]="getTitleText()" class="dekra-link float-left">
		<svg-icon class="dekra-logo" src="../assets/img/dekra_logo.svg"></svg-icon>
	</a>
} @else {
	<a [title]="getTitleText()" class="dekra-logo dekra-link float-left" style="margin-bottom: 20px;"><img id="without-label" src="../assets/img/dekra_logo_pl.png"></a>
}

